import {
  AdjustedSection,
  ChapterButton,
  ChapterSection,
  ChapterSectionContent,
  ChapterSectionHeader,
  Content,
  ContentContainer,
  ContentIndexSection,
  FooterSection,
  Heading,
  HeadingRow,
  SocialsContainer,
  SubHeadingSection,
} from './styles';
import { Col, Row } from 'react-styled-flexboxgrid';

import PageHeadline from '@/components/ui/elements/PageHeadline';
import PostContent from '@/components/Blog/PostContent';
import PostSocials from '@/components/Blog/PostSocials';
import React from 'react';
import ResponsiveGrid from '@/components/ui/ResponsiveGrid';
import SectionHeadline from '@/components/ui/elements/SectionHeadline';
import scrollToSection from '@/lib/scrollToSection';
import { slug } from '@/utils/helpers';

interface LayoutProps {
  post: Record<string, unknown>;
  permalink?: string;
}

const ChaptersLayout: React.FC<LayoutProps> = ({ post, permalink }) => {
  const { title, author, metaDescription, chaptersLayout, mainImage } = post as {
    title: string;
    author: { name: string };
    metaDescription: string;
    chaptersLayout: {
      subheading?: unknown;
      chapters?: Array<{ name?: string; title: string; body?: unknown }>;
      showFooter?: boolean;
      footer?: { heading: string; body?: unknown };
    };
    mainImage: unknown;
  };
  // const { footer, showFooter, chapters = [], subheading } = chaptersLayout;
  return (
    <AdjustedSection bgColor="white">
      <ResponsiveGrid style={{ overflowX: 'hidden' }}>
        <HeadingRow>
          <Col xs={12}>
            <PageHeadline xs={48} sm={72} md={72} lg={80}>
              <p>{title}</p>
            </PageHeadline>
            <PageHeadline as="h2" xs={24} sm={32} md={32} lg={32}>{`By ${author.name}`}</PageHeadline>
          </Col>
        </HeadingRow>
      </ResponsiveGrid>
      <Content>
        <SocialsContainer>
          <div>
            <PostSocials permalink={permalink} title={title} description={metaDescription} image={mainImage} minimal />
          </div>
        </SocialsContainer>
        {chaptersLayout?.subheading && (
          <SubHeadingSection>
            <ResponsiveGrid>
              <Row>
                <Col xs={12}>
                  <ContentContainer>
                    <PostContent content={chaptersLayout?.subheading} />
                  </ContentContainer>
                </Col>
              </Row>
            </ResponsiveGrid>
          </SubHeadingSection>
        )}
        <ContentIndexSection>
          <Row>
            <Col xs={12} sm={5} md={4} lg={4}>
              <SectionHeadline xs={40} sm={40} md={48} lg={56}>
                Table of Contents
              </SectionHeadline>
            </Col>

            <Col xs={12} sm={7} md={8} lg={8}>
              <ol>
                {chaptersLayout?.chapters?.map((chapter) => {
                  const chapterName = chapter.name || '';
                  return (
                    <li key={chapterName}>
                      <ChapterButton onClick={scrollToSection(slug(chapterName))}>
                        <h4>{chapter.title}</h4>
                      </ChapterButton>
                    </li>
                  );
                })}
              </ol>
            </Col>
          </Row>
        </ContentIndexSection>
        {chaptersLayout?.chapters?.map((chapter) => {
          const chapterName = chapter.name || '';
          return (
            <ChapterSection id={slug(chapterName)} key={chapterName}>
              <ChapterSectionHeader>
                <Heading>
                  <Col xs={12}>
                    <h4>{chapterName}</h4>
                  </Col>
                  <Col xs={12}>
                    <h2>{chapter.title}</h2>
                  </Col>
                </Heading>
              </ChapterSectionHeader>
              <ChapterSectionContent>
                <Col xs={12}>{chapter.body && <PostContent content={chapter.body} />}</Col>
              </ChapterSectionContent>
            </ChapterSection>
          );
        })}
        {chaptersLayout?.showFooter && chaptersLayout?.footer && (
          <FooterSection>
            <div>
              <Col xs={12}>
                <h2>{chaptersLayout?.footer.heading}</h2>
              </Col>
              <Col xs={12}>{chaptersLayout?.footer.body && <PostContent content={chaptersLayout?.footer.body} />}</Col>
            </div>
          </FooterSection>
        )}
      </Content>
    </AdjustedSection>
  );
};

export default ChaptersLayout;
